import { createApi, retry } from '@reduxjs/toolkit/query/react';

import { accountHeaderBaseQuery } from './base-queries/account-header';

const { app } = PULSE;
const { API_RETRY_COUNT } = app.common.CONSTANTS;

// RTK Query update: Define an api service with a base URL and retry attempts
// RTK Query update: Endpoints can be added here or injected in components
export const aflApi = createApi({
    reducerPath: 'aflAPI',
    baseQuery: retry(accountHeaderBaseQuery, { maxRetries: API_RETRY_COUNT }),
    endpoints: (build) => ({
        getCompetitions: build.query({
            query: () => 'competitions?pageSize=50',
            transformResponse: (response) => response?.competitions
        }),
        getTeams: build.query({
            query: (compSeasonId) =>
                `teams?compSeasonId=${compSeasonId}&pageSize=100`,
            transformResponse: (response) => response?.teams
        })
    })
});

export const { useGetCompetitionsQuery, useGetTeamsQuery } = aflApi;
